document.addEventListener('DOMContentLoaded',()=>{
  const finder=document.querySelector('[data-bike-finder]');
  const storageKey='ozmaBikeSelection';
  const modelos={
    'Italika':['125Z','250SZ','250Z','280Z','DM200','DM250','Vort-X 200','Vort-X 300'],
    'Bajaj':['Dominar 400','N250','RS200'],
    'CF Moto':['NK250','NK300','NK450'],
    'Vento':['Crossmax 250','Nitrox 250','Nitrox 250 T3','Nitrox 300 T3','Rocketman 250','Rocketman 300','Storm 250','Tornado 250','Tornado 300']
  };
  const readBike=()=>{
    try{return JSON.parse(sessionStorage.getItem(storageKey)||'null')}catch{return null}
  };
  const writeBike=(bike)=>{
    try{sessionStorage.setItem(storageKey,JSON.stringify(bike))}catch{}
  };
  const normalizeQuery=(value)=>String(value||'').trim().replace(/\s+/g,' ').toLocaleLowerCase('es-MX');
  const bikeQuery=(bike)=>'"'+bike.marca+' '+bike.modelo+'"';
  const bikeLabel=(bike)=>[bike.marca,bike.modelo,bike.year].filter(Boolean).join(' ');
  const contactSubmit=document.querySelector('form[action*="/contact"] .submit-button[type="submit"]');
  if(contactSubmit){
    contactSubmit.textContent='';
    contactSubmit.setAttribute('aria-label','Enviar mensaje');
  }
  if(finder){
    const marca=finder.querySelector('[name="marca"]');
    const modelo=finder.querySelector('[name="modelo"]');
    const year=finder.querySelector('[name="year"]');
    const summary=finder.querySelector('[data-bike-summary]');
    const cargarModelos=(selected='')=>{
      const lista=modelos[marca.value]||[];
      modelo.innerHTML='<option value="">'+(lista.length?'Selecciona modelo':'Selecciona primero una marca')+'</option>';
      lista.forEach(nombre=>{const option=document.createElement('option');option.value=nombre;option.textContent=nombre;modelo.appendChild(option)});
      modelo.disabled=lista.length===0;
      modelo.value=lista.includes(selected)?selected:'';
    };
    const mostrarResumen=(bike)=>{
      if(!summary||!bike?.marca||!bike?.modelo)return;
      summary.innerHTML='<strong>Tu moto:</strong> '+bikeLabel(bike);
      summary.hidden=false;
    };
    marca.addEventListener('change',()=>{cargarModelos();if(summary)summary.hidden=true});
    modelo.addEventListener('change',()=>{if(marca.value&&modelo.value)mostrarResumen({marca:marca.value,modelo:modelo.value,year:year.value})});
    year.addEventListener('input',()=>{year.setCustomValidity('');if(marca.value&&modelo.value)mostrarResumen({marca:marca.value,modelo:modelo.value,year:year.value})});
    finder.addEventListener('submit',(event)=>{
      event.preventDefault();
      if(!marca.value||!modelo.value){finder.reportValidity();return}
      if(year.value&&!/^\d{4}$/.test(year.value)){year.setCustomValidity('Escribe el año con 4 dígitos.');year.reportValidity();return}
      year.setCustomValidity('');
      const bike={marca:marca.value,modelo:modelo.value,year:year.value};
      bike.query=bikeQuery(bike);
      writeBike(bike);mostrarResumen(bike);
      window.location.href='/search?q='+encodeURIComponent(bike.query)+'&type=product&options%5Bprefix%5D=none';
    });
  }
  const resultSummary=document.querySelector('[data-bike-result-summary]');
  if(resultSummary){
    const bike=readBike();
    const currentQuery=new URLSearchParams(window.location.search).get('q');
    const savedQuery=bike?.query||((bike?.marca&&bike?.modelo)?bikeQuery(bike):'');
    const queryMatches=Boolean(currentQuery&&savedQuery&&normalizeQuery(currentQuery)===normalizeQuery(savedQuery));
    if(bike?.marca&&bike?.modelo&&queryMatches){
      resultSummary.textContent='Tu moto: '+bikeLabel(bike)+' \u00b7 Resultados que coinciden con tu marca y modelo.';
      resultSummary.hidden=false;
      const aiLink=document.querySelector('[data-bike-ai-link]');
      if(aiLink){
        const message='Hola Ozma IA, no encontr\u00e9 una pieza para mi '+bikeLabel(bike)+'. \u00bfMe ayudas?';
        aiLink.href='https://wa.me/525652502129?text='+encodeURIComponent(message);
      }
    }else{
      resultSummary.hidden=true;
    }
  }
  document.querySelectorAll('[data-oz-product]').forEach(productRoot=>{
    const mainImage=productRoot.querySelector('#OzmaMainProductImage');
    productRoot.querySelectorAll('[data-oz-image]').forEach(button=>button.addEventListener('click',()=>{
      if(mainImage)mainImage.src=button.dataset.ozImage;
      productRoot.querySelectorAll('.oz-product-thumb').forEach(el=>el.classList.remove('is-active'));
      button.classList.add('is-active');
    }));
    const select=productRoot.querySelector('[data-oz-variant]');
    if(select){
      const price=productRoot.querySelector('[data-oz-price]');
      const compare=productRoot.querySelector('[data-oz-compare]');
      const stock=productRoot.querySelector('[data-oz-stock]');
      const add=productRoot.querySelector('[data-oz-add]');
      const syncVariant=()=>{
        const option=select.options[select.selectedIndex];
        if(price)price.textContent=option.dataset.price||'';
        if(compare){compare.textContent=option.dataset.compare||'';compare.hidden=!option.dataset.compare}
        const available=option.dataset.available==='true';
        if(stock){stock.textContent=available?'● Disponible para compra':'● Agotado';stock.classList.toggle('is-out',!available)}
        if(add){add.disabled=!available;add.textContent=available?'Agregar al carrito':'Agotado'}
      };
      select.addEventListener('change',syncVariant);
    }
  });
});
